import React from 'react';
import { PlayIcon, StethoscopeIcon } from 'lucide-react';
import { DOCTORS } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
export function Doctors() {
  return <Section className="py-16 md:py-20" data-id="element-70" data-mp="15ou0hn73oor">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-71" data-mp="16q4ol0au95y">
        <Eyebrow data-id="element-72" data-mp="3sd1byyvwk65q">Doctor Recommendations</Eyebrow>
        <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl lg:text-[2.75rem]" data-id="element-73" data-mp="3secfcxlfrbwb">
          Trusted by healthcare professionals
        </h2>
      </Reveal>

      <div className="mt-12 flex gap-5 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-74" data-mp="owc499kl2qeh">
        {DOCTORS.map((doc, i) => <Reveal key={doc.name} delay={i * 0.06} data-id="element-75" data-mp="ey4qezllcogp" data-mpi={i}>
            <div className="group flex w-72 shrink-0 flex-col overflow-hidden rounded-2xl border border-forest/10 bg-ivory/60" data-id="element-76" data-mp="exd7ao96kj7b">
              <div className="relative flex aspect-[4/5] items-center justify-center bg-forest-deep" data-id="element-77" data-mp="2znu59cmaoa9e">
                <StethoscopeIcon className="h-14 w-14 text-ivory/20" data-id="element-78" data-mp="um7ms71mi6mq" />
                <button className="absolute inset-0 flex items-center justify-center" aria-label={`Play ${doc.name}'s video`} data-id="element-79" data-mp="uk4pr321zd8i">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-ivory/90 text-forest transition-transform group-hover:scale-110" data-id="element-80" data-mp="kni5afdn2o70">
                    <PlayIcon className="ml-0.5 h-6 w-6 fill-forest" data-id="element-81" data-mp="bv6f8umft2rk" />
                  </span>
                </button>
                <span className="absolute bottom-3 right-3 rounded-full bg-forest/70 px-2 py-0.5 text-[10px] font-medium text-ivory" data-id="element-82" data-mp="gnhr8vugcf0h">
                  0:45
                </span>
              </div>
              <div className="p-5" data-id="element-83" data-mp="6xog1vy821wr">
                <p className="text-sm leading-relaxed text-forest/75" data-id="element-84" data-mp="6uisil58r835">“{doc.quote}”</p>
                <p className="mt-4 font-serif text-lg text-forest" data-id="element-85" data-mp="3p31i5o7nhlcd">{doc.name}</p>
                <p className="text-xs text-sage" data-id="element-86" data-mp="3t2jqzlm765yu">{doc.role}</p>
              </div>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}